import { useEventBus } from '@/util/use-event-bus/index';
import { EventBusType } from '@/util/use-event-bus/types/eventbus';

const eventBus: EventBusType = useEventBus();

export default eventBus;
